window.addEventListener('load', function () {
    var startTime = new Date().getTime();
    var checkbox = setInterval(function () {
        var form = document.querySelector('.klaviyo-form.klaviyo-form-version-cid_3');
        if (form) {
            clearTimeout(checkbox);
            var icon = form.querySelector('#Shape');
            icon.style.fill = 'rgb(24, 70, 138)';
            var otherTextInput = document.querySelector('.klaviyo-form.klaviyo-form-version-cid_3 > div > div:nth-child(6)');
            var checkBoxInput = document.getElementById('industry_selector__7__24');

            otherTextInput.style.display = "none";
            checkBoxInput.addEventListener("change", function () {
                if (checkBoxInput.checked) {
                    otherTextInput.style.display = "block";
                } else {
                    otherTextInput.style.display = "none";
                }
            })
        } else {
            if (new Date().getTime() - startTime > 30000) {
                clearTimeout(checkbox);
            }
        }
    }, 1000);

    var PathName = window.location.pathname;
    if (
        PathName.includes('covid-19-response') ||
        PathName.includes('contact') ||
        document.getElementById('klavyio-form')
    ) {
        var textInputInterval = setInterval(function () {
            var textInput = document.querySelectorAll('[aria-label="Message:"]');
            if (textInput) {
                for (var i = 0; i < textInput.length; i++) {
                    var currentTextInput = textInput[i];
                    currentTextInput.style.display = 'none';
                    var textArea = document.createElement('textArea');
                    textArea.className = 'form-textarea font--gotham-medium';
                    clearTimeout(textInputInterval);
                    currentTextInput.parentNode.insertBefore(textArea, currentTextInput);
                    textArea.addEventListener(
                        'keyup',
                        function () {
                            var currentVal = $(this)
                                .val()
                                .replace(/(?:\r\n|\r|\n)/g, ' ');
                            var relevantTextInput = this.parentNode.querySelector('input');
                            relevantTextInput.value = currentVal;
                            var ev = new Event('input');
                            relevantTextInput.dispatchEvent(ev);
                        },
                        false
                    );
                }
            }
        }, 1000);

        window.addEventListener('klaviyoForms', function (e) {
            if (e.detail.type == 'submit') {
                const EVENT_NAME = e.detail.metaData.Trigger;
                const PUBLIC_KEY = 'UVynYU';

                let customer_email = e.detail.metaData.$email;
                if (customer_email) {
                    const options = {
                        method: 'POST',
                        headers: {
                            Accept: 'text/html',
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            data:
                                '{"token": "' +
                                PUBLIC_KEY +
                                '", "event": "' +
                                EVENT_NAME +
                                '", "customer_properties": {"$email": "' +
                                customer_email +
                                '"}}',
                        }),
                    };

                    fetch('https://a.klaviyo.com/api/track', options)
                        .then((response) => response.json())
                        .then((response) => {
                            //console.log(response);
                        })
                        .catch((err) => console.error(err));
                }
            }
        });
    } else if (PathName.includes('blogs/solutions-training-how-to')) {
        // For blog filter boxes
        let sideBox = document.getElementsByClassName('side_box');
        let sideBoxFilters = document.getElementsByClassName('side-box__header');
        let sideBoxFiltersContent =
            document.getElementsByClassName('side-box__content');

        for (let i = 0; i < sideBox.length; i++) {
            sideBoxFiltersContent[i].style.height =
                sideBoxFiltersContent[i].offsetHeight + 'px';

            sideBoxFilters[i].addEventListener('click', () => {
                sideBoxFiltersContent[i].classList.toggle('active');
                sideBoxFilters[i].classList.toggle('active');
            });
        }
    }

    let links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname && !links[i].href.includes('javascript')) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : undefined;
    }
    function setCookie(name, value) {
        document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=Lax';
    }

    let isGeoRejected = getCookie("dx_geo_rejected");

    if (isGeoRejected !== "true") {
        // No Geo Cookie: Geocode via browser API
        if (getCookie("dx_geo_state") === undefined) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    let visitorLocationURL = "https://nominatim.openstreetmap.org/reverse?lat="
                        + position.coords.latitude + "&lon="
                        + position.coords.longitude + "&format=json";

                    fetch(visitorLocationURL)
                        .then(r => r.json())
                        .then(function (data) {
                            setCookie("dx_geo_state", data.address.state);
                            displayGeoStuff(data.address.state);
                        });
                }, function () {
                    // Visitor rejected geo-location access or timed-out
                    setCookie("dx_geo_rejected", "true");
                }, {
                    timeout: 10000,
                    enableHighAccuracy: true
                });
            }
        } else {
            // Geo Cookie Exists: Geocode via saved cookie
            displayGeoStuff(getCookie("dx_geo_state"));
        }
    }
});

// TESTIMONIALS DROPDOWN

var resourceDropdownToggle = document.getElementsByClassName(
    'resource-dropdown__toggle'
);
var resourceDropdown = document.getElementsByClassName(
    'testimonialResourceDropdown'
);

if (resourceDropdownToggle && resourceDropdown) {
    for (var dropdown of resourceDropdown) {
        dropdown.style.height = dropdown.offsetHeight + 'px';
    }

    for (var toggle of resourceDropdownToggle) {
        toggle.addEventListener('click', (e) => {
            if (resourceDropdownToggle.length > 1) {
                var closestDropdown = e.target.parentNode.querySelector(
                    '.testimonialResourceDropdown'
                );
                closestDropdown.classList.toggle('active');
            } else {
                for (var dropdown of resourceDropdown)
                    dropdown.classList.toggle('active');
            }
        });
    }
}

// Displays fields based on visitor's geolocation
const displayGeoStuff = (visitor_state) => {
    // Prop 65 and VOC html elements
    let geoProp65Html = document.getElementsByClassName('prop65__container')[0];
    let geoVocHtml = document.getElementById('geo_voc-warning');

    // Prop 65 geo handle
    if (geoProp65Html)
        if (visitor_state === 'California')
            // Display Prop 65 warning in California
            geoProp65Html.classList.add('geoCali');

    /*// VOC geo handle
    if (geoVocHtml) {
      // Split VOC data by comma-space
      let geoVocStates = geoVocHtml.dataset.voc.split(', ');

      // Rename Washington D.C to District of Columbia
      geoVocStates = geoVocStates.map((state) => {
        if (state === 'Washington D.C') state = 'District of Columbia';

        return state;
      });

      // Display VOC copy if in VOC state
      if (geoVocStates.includes(visitor_state))
        geoVocHtml.classList.add('geoVoc');
    }*/
};

function isMobileWidth() {
    return window.innerWidth <= 769;
}

// ADD TO CART MOBILE BUTTON
const navbar = document.querySelector('#mobile_add_to_cart_buttons');
const quantityInBar = document.querySelector('.desc_blk_bot .sold-online__description-container .product-page-qty');
const quantityToHide = document.querySelector('#mobile_add_to_cart_buttons .product-page-qty');

const addToCartInBar = document.querySelector('.desc_blk_bot .sold-online__description-container #addToCart');
const mobileButtonsToHide = document.querySelector('#mobile_add_to_cart_buttons');

let hasBoundMobileScrollHandler = false;

function handleMobileAddToCartScroll() {
    if (!navbar || !quantityInBar || !quantityToHide || !addToCartInBar || !mobileButtonsToHide) return;

    const quantityPosition = quantityInBar.getBoundingClientRect().top;
    const offset = window.innerHeight - navbar.offsetHeight;
    if (quantityPosition - offset <= 0) {
        quantityToHide.style.display = 'none';
    } else {
        quantityToHide.style.display = 'block';
    }

    const addToCartPosition = addToCartInBar.getBoundingClientRect().top;
    if (addToCartPosition - offset <= 0) {
        mobileButtonsToHide.style.display = 'none';
    } else {
        mobileButtonsToHide.style.display = 'flex';
    }
}

function handleScreenResize() {
    if (!navbar || !quantityInBar || !quantityToHide || !addToCartInBar || !mobileButtonsToHide) return;

    if (isMobileWidth()) {
        if (!hasBoundMobileScrollHandler) {
            window.addEventListener('scroll', handleMobileAddToCartScroll);
            hasBoundMobileScrollHandler = true;
        }
        handleMobileAddToCartScroll();
    } else if (hasBoundMobileScrollHandler) {
        window.removeEventListener('scroll', handleMobileAddToCartScroll);
        hasBoundMobileScrollHandler = false;
    }
}

window.addEventListener('resize', handleScreenResize);
handleScreenResize();
